import React, { useState, useEffect, useMemo } from 'react'
import useData from '../hooks/useData'
import Loading from './Loading'
import Icon from './Icon'
import Clipboard from 'react-clipboard.js'
import provider from '../modules/provider'
import { NodeArray } from './Amazon'
import Flag from './Flag'
import { FRONT_STORE_ARRAY } from '../constants/'

// const scroll = () => {
//     const rb = document.querySelector('#resource-bucket')
//     rb && (rb.scrollTop = rb.scrollHeight)
// }

const AmazonProductSmall = React.memo(function AmazonProductSmall(props) {
    // console.log({props})
    const ASIN = props.external_id || props.ASIN || (props.providerProductId && (props.providerProductId.ASIN || props.providerProductId.creativeASIN))
    const { site } = props
    // console.log({ props })
    const [error, setError] = useState(props.error)
    const productDetails = useData(
        'provider/amazon/product_details?ASIN=' + (props.providerProductId && ASIN) + '&tracking_id=' + props.tracking_id + '&locale=' + props.locale,
        [typeof ASIN !== 'undefined', ASIN !== 'undefined', !props.external_id, !error]
    )
    // console.log({ props }, { productDetails })
    // console.log(ASIN, typeof ASIN !== 'undefined', ASIN !== 'undefined', !props.external_id)

    const [displayImages, setDisplayImages] = useState(false)
    useEffect(() => {
        if (productDetails.isReady && !props.external_id) {
            // console.log('yes, we update')
            const item = productDetails && productDetails.data && productDetails.data[0]
            let product
            if (item) {
                product = {
                    ...item,
                    origin: props.origin,
                    locale: props.locale,
                    displayUrl: props.displayUrl,
                    originalUrl: props.originalUrl,
                    error: undefined,
                }
            } else {
                // console.log('ERROR')
                const error_msg = `Can't get details for product ${ASIN}`
                product = { error: error_msg, ASIN: ASIN, origin: props.origin, displayUrl: props.displayUrl, originalUrl: props.originalUrl }
                setError(error_msg)
            }
            const prod = { payload: props.payload, ...product }
            prod.image_url = props.image_url || prod.image_url
            props.updateProduct && props.updateProduct(props.id, prod)
        }
    }, [productDetails.data])

    const retry = () => {
        setError(false)
    }
    useEffect(() => {
        setError(props.error)
    }, [props.error])

    useEffect(() => {
        if (!props.external_id && typeof ASIN !== 'undefined' && ASIN !== 'undefined') {
            // scroll()
        }
    })
    // useLayoutEffect(() => {productDetails.isReady&&scroll()}, [productDetails.isReady])

    const onDragStartNewBlock = (e, param) => {
        e.dataTransfer.setData('text/plain', '')
        window.drag_target = null
        const { type, payload } = param
        window.drag_target_id = type
        window.drag_target_payload = payload
    }

    const DDprops = (type) => ({
        draggable: true,
        onDragStart: (e) => onDragStartNewBlock(e, type),
        onDrop: () => {
            console.log('element dropped')
        },
        onDragOver: (event) => event.preventDefault(),
        onDragEnd: () => {
            console.log('onDragEnd')
        },
    })
    // console.log({ props })

    const locale = useMemo(() => FRONT_STORE_ARRAY.find((o) => props.href?.includes(o.url))?.locale, [FRONT_STORE_ARRAY, props.href])

    return (
        <>
            {(props.external_id && (
                <div className="product-bucket-controlled-width amazon-product">
                    {(props.node_array && (
                        <small className="d-block">
                            <small>
                                {/* <BrowseNodes {...props.BrowseNodes} /> */}
                                <NodeArray node_array={props.node_array} />
                            </small>
                        </small>
                    )) ||
                        null}
                    <div className="row">
                        <div className="col-xxl-3 pt-2 text-center">
                            {(props.image_url && (
                                <img
                                    alt=""
                                    src={props.image_url}
                                    className="amazon-product-thumbnail img-fluid"
                                    {...DDprops({
                                        type: 'amazon',
                                        payload: { ...props, image_url: props.image?.large?.url, locale: site?.locale, tracking_id: site?.tracking_id },
                                    })}
                                />
                            )) ||
                                null}
                        </div>
                        <div className="col-xxl-9">
                            <small className="d-block">
                                {(locale && <Flag locale={locale} className="mr-2" />) || null}
                                <strong>{props.label}</strong>
                            </small>
                            {(props.price && (
                                <>
                                    <span className="badge badge-info">{props.price}</span>
                                </>
                            )) ||
                                null}
                            {(typeof props.available !== 'undefined' && (
                                <>
                                    <span className={'badge badge-' + ((props.available && 'info') || 'danger') + ' ml-1'}>
                                        {(props.available && 'Available') || 'Unavailable'}
                                    </span>
                                </>
                            )) ||
                                null}
                            <Clipboard className="badge badge-secondary ml-1 pointer" data-clipboard-text={props.href}>
                                <i className="fal fa-link" />
                            </Clipboard>
                            <a
                                href={'https://dereferer.me/?' + escape(props.detailed_url || props.sanitizedUrl)}
                                className="badge badge-secondary ml-1"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <Icon name="external" />
                            </a>
                            <small className="text-muted ml-1">{props.external_id}</small>
                        </div>
                    </div>
                    {(props.image_url_array && props.image_url_array.length && props.image_url_array.length > 1 && (
                        <>
                            {(displayImages && <hr style={{ maxWidth: '50%' }} />) || null}
                            {(displayImages && (
                                <ul className="list-unstyled row">
                                    {props.image_array.map((image, index) => (
                                        <li className="col-3 text-center" key={`image-${index}`}>
                                            <img
                                                alt=""
                                                src={image.small?.url}
                                                className="amazon-product-thumbnail img-fluid mt-3"
                                                {...DDprops({
                                                    type: 'amazon',
                                                    payload: { ...props, image_url: image.large?.url, locale: site.locale, tracking_id: site.tracking_id },
                                                })}
                                            />
                                        </li>
                                    ))}
                                </ul>
                            )) ||
                                null}
                            <div className="w-100 text-center">
                                {(displayImages && (
                                    <small onClick={() => setDisplayImages(false)} className="btn btn-xs btn-link">
                                        Hide images <Icon name="angle-up" />
                                    </small>
                                )) || (
                                    <small onClick={() => setDisplayImages(true)} className="btn btn-xs btn-link">
                                        Show {props.image_url_array.length} images <Icon name="angle-down" />
                                    </small>
                                )}
                            </div>
                        </>
                    )) ||
                        null}
                </div>
            )) ||
                (error && (
                    <>
                        <span className="badge badge-danger mr-2">error</span>
                        <small>{error}</small>
                        <br />
                        <span className="btn btn-secondary btn-xs" onClick={retry}>
                            Retry
                        </span>
                    </>
                )) || <Loading size="4" text="Fetching details from Amazon API" />}
        </>
    )
})

export default AmazonProductSmall
